/* eslint-disable */
export default {
  header: '聯絡支援部門',
  toggleTitle: '1. 開啟錯誤追蹤模式',
  toggleDescription:
    '這有助於我們找到問題之所在，但可能會對應用程式效能產生些許影響。',
  downloadTitle: '2. 重現問題後，請下載錯誤記錄。',
  downloadButton: '下載',
  downloadDisabledTitle: '下載錯誤記錄前，請先開啟錯誤追蹤模式。',
  sendTitle: '3. 將記錄傳送給支援團隊',
  createSupportTicket: '建立支援票證',
  sendDescription:
    ' 以聯絡我們的支援團隊。然後將記錄傳送給支援團隊，以利疑難排解。',
  privacyNotice:
    '將記錄下載並傳送給我們，即表示您允許 RingCentral 存取特定記錄相關資訊，以利疑難排解及錯誤處理。如需深入瞭解 RingCentral 如何處理個人資料，請查看我們的 ',
  privacyNoticeLink: '服務條款',
  and: ' 和 ',
  privacyNoticeEnd: '隱私權注意事項。',
  needLeavePage:
    '錯誤追蹤執行期間，您可以離開此頁面。重現問題後，請回到此頁面下載記錄檔案。',
  downloading: '正在下載',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
